import React, { useState, useEffect } from "react";
import "../AddPage/AddSalesTarget.css";
import axios from "axios";

const AddSalesTarget = ({ successMessage, setSuccessMessage }) => {
  const [employeeResponse, setEmployeeResponse] = useState([]);
  const [GetMonth, setGetMonth] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  const [firstItem, setFirstItem] = useState({
    target_for_month: "",
    user_id: "",
    target_by_lead: "",
    target_by_revenue: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem({
      ...firstItem,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}userpost/AddUpdateSalesTarget`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Handle the response here (e.g., show a success message)


      setSuccessMessage("Data successfully submitted");
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setEmployeeResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });

    axios
      .get(`${baseAPI}userGet/GetTargetForMonth`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setGetMonth(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });

  }, []);

  return (
    <div className="container-fluid">
      <br />

      <div className="SalesTargetDetail">
        {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )}
        <form className="SalesTarget-form" onSubmit={handleSubmit}>
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Month</td>
              <td>Name*</td>
              <td>Target By Lead</td>
              <td>Target By Revenue</td>
            </tr>

            <tr>


              <td style={{ width: "10%" }}>
                <select
                  className="form-control"
                  name="target_for_month"
                  onChange={handleChange}
                  value={firstItem.target_for_month}
                >
                  <option value="0">Select an option</option>
                  {GetMonth.map((item) => (
                    <option value={`${item.MonthName},${item.Year}`} key={`${item.MonthName}-${item.Year}`}>
                      {`${item.MonthName}, ${item.Year}`}
                    </option>
                  ))}
                </select>
              </td>

              <td style={{ width: "30%" }}>
                <select
                  className="form-control"
                  name="user_id"
                  onChange={handleChange}
                  value={firstItem.user_id}
                >
                  <option value="0">Select an option</option>
                  {employeeResponse.map((item) => (
                    <option value={item.customer_id}>{item.name}</option>
                  ))}
                </select>
              </td>
              <td style={{ width: "30%" }}>
                <input
                  className="form-control"
                  type="number"
                  name="target_by_lead"
                  value={firstItem.target_by_lead}
                  onChange={handleChange}
                />
              </td>
              <td style={{ color: "#28A745", width: "30%" }}>
                <input
                  className="form-control"
                  type="number"
                  name="target_by_revenue"
                  value={firstItem.target_by_revenue}
                  onChange={handleChange}
                />
              </td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addSalesTarget-button">
            <button
              type="button"
              style={{ backgroundColor: "#F15843", color: "white" }}
              onClick={() =>
                setFirstItem({
                  target_for_month: "",
                  user_id: "",
                  target_by_lead: "",
                  target_by_revenue: "",
                  createdBy: "Vishal",
                  is_active: "true",
                })
              }
            >
              Reset
            </button>
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >

              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddSalesTarget;
